import React, {useMemo} from "react";
import Form from "../../base/form";
import {Col, Row} from "reactstrap";
import Button from "../../base/button/button";
import classnames from "classnames";
import {InputForm} from "../../base/input/input";
import {MuiRFF, Yup} from '../../form';

const schema = Yup.object().shape({
    keyword: Yup.string().trim().nullable(),
});

const validate = MuiRFF.makeValidate(schema);
const required = MuiRFF.makeRequired(schema);

const TerritoriesSearchSection = ({searchData}) => {

    const filters = useMemo(() => ({
        ...(searchData.filters ?? {}),
    }), [searchData.filters])

    /**@type {Record<string, any>}*/
    const initialValues = useMemo(() => ({
        keyword: filters?.keyword ?? '',
    }), [filters?.keyword])

    /**
     * Changes the query of the url to the query containing the searched values so that the list pages of orders can
     * use them and search related items.
     * @param values {any} form values
     */
    const onSubmit = (values) => {
        searchData.setFilters(values);
    }

    return (
        <Form
            onSubmit={onSubmit}
            validate={validate}
            initialValues={initialValues}
            render={({submitting, values, form}) => {
                const colClassName = 'px-3 mb-4';
                return (
                    <Row className='align-items-center justify-content-center'>
                        <Col xs={12} className={classnames(colClassName)}>
                            <InputForm
                                onChange={(val) => form.change('keyword', val)}
                                value={values?.keyword ?? ''}
                                label={'Keywords'}
                                name={'keyword'}
                                type={'text'}
                                required={required.keyword}
                            />
                        </Col>
                        <Col xs={12}
                             className='px-3 mt-2 align-items-center row no-gutters justify-content-center align-items-center'>
                            <Button
                                disabled={!!submitting}
                                type={'submit'}
                                variant={'contained'}
                                color={'primary'}
                                className='py-3 px-8'
                            >
                                Search
                            </Button>
                        </Col>
                    </Row>
                );
            }}
        />
    );
}

export default TerritoriesSearchSection;
